import Annotation from "./annotation";
import { setLineStyle } from "../canvasUtils";
export default class ViewFinder extends Annotation {
  constructor(){
    super();
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.lineWidth = 3;
    this.color = "red";
  }
  
  draw(ctx){    
    if (!this.width) return;
    setLineStyle(ctx, this);

    ctx.beginPath();
    ctx.strokeRect(this.x, this.y, this.width, this.height);
    ctx.closePath();
  }

  updateViewFinder(fittedImgSize, transform){
    if (!fittedImgSize || !transform) return;

    const scaledZoom = transform.zoom / transform.fitZoom;
    let offset = 1100 / window.innerHeight;

    this.width = (fittedImgSize.w / scaledZoom) - offset;
    this.height = (fittedImgSize.h / scaledZoom) - offset;

    this.x = fittedImgSize.w * (transform.centerX - 1 / (2 * scaledZoom));
    this.y = fittedImgSize.h * (transform.centerY - 1 / (2 * scaledZoom));

    this.signalReady();
  }
}